// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import ClientArea from './pages/ClientArea';
import Finance from './pages/Finance';
import Contracts from './pages/Contracts';
import Scheduling from './pages/Scheduling';
import ScrollToTop from './components/ScrollToTop';
import './styles.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/client-area" element={<ClientArea />} />
        <Route path="/finance" element={<Finance />} />
        <Route path="/contracts" element={<Contracts />} />
        <Route path="/scheduling" element={<Scheduling />} />
      </Routes>
      <WhatsAppButton />
      <Footer />
    </Router>
  );
}

export default App;